import { render, staticRenderFns } from "./TokenConfirmationModal.vue?vue&type=template&id=128380be&scoped=true"
import script from "./TokenConfirmationModal.vue?vue&type=script&lang=js"
export * from "./TokenConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./TokenConfirmationModal.vue?vue&type=style&index=0&id=128380be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128380be",
  null
  
)

export default component.exports